// Portfolio game data

export const GAMES = [
  {
    id: "fight-for-brainrots",
    name: "Fight for Brainrots!",
    image: "https://tr.rbxcdn.com/180DAY-cc62f513606f7af9637a80372adb89d1/512/512/Image/Png/noFilter",
    href: "https://www.roblox.com/games/72332082045397/Fight-for-Brainrots",
    universeId: 10023193236,
    plays: "198K",
    peakCcu: "204",
    contribution: "Fully coded",
  },
  {
    id: "spin-for-ugc",
    name: "Spin For UGC",
    image: "/spin-for-ugc.webp",
    href: "https://www.roblox.com/games/15637152701/Spin-For-UGC",
    plays: "200K",
    peakCcu: "80",
    contribution: "Fully coded",
    note: "Original game with all the visits got bought and privated.",
  },
  {
    id: "dig-stuff",
    name: "Dig Stuff",
    image: "https://tr.rbxcdn.com/180DAY-177de431ba6e5db0653aa2de5cf4945c/512/512/Image/Png/noFilter",
    href: "https://www.roblox.com/games/70698000296435/Dig-Stuff",
    universeId: 8138309018,
    plays: "332K",
    contribution: "Partially coded",
  },
];

export const SKILLS = [
  { name: "FPS"},
  { name: "Simulators"},
  { name: "Tower Defense"},
  { name: "Round Based"},
  { name: "Obbies"},
  { name: "Clicker"},
  { name: "Tycoons"}, 
  { name: "Brainrot"}, 
];

export const PAYMENT_AND_TERMS = {
  paymentMethods: [
    { name: "USD" },
    { name: "Robux" },
    { name: "Crypto" },
  ],
  terms: [
    "I may accept a percentage-based arrangement for the right project.",
    "Upfront payment is preferred, but I'm also open to milestone-based payments.",
    "My rates are flexible, and we can agree on a price in DMs.",
  ],
};

export const SHOWCASE_VIDEOS = [
  {
    id: "showcase-1",
    label: "Clip 01",
    title: "Tower Defense",
    description: "A Roblox tower defense system with enemy waves, pathing, tower placement, and upgrade-focused gameplay.",
    src: "/videos/tower-defense.mp4",
    poster: "",
  },
  {
    id: "showcase-2",
    label: "Clip 02",
    title: "Building System",
    description: "A Roblox placement/building system with snapping, previews, and server validation.",
    src: "/videos/building-showcase.mp4",
    poster: "",
  },
];

export const SNIPPETS = [
  {
    id: "datastore",
    label: "DataStore",
    title: "Safe player data with auto-retry",
    description: "Handles save/load with pcall retries and queues to avoid data loss on disconnect.",
    code: `local DataStoreService = game:GetService("DataStoreService")
local Players = game:GetService("Players")
local PlayerData = DataStoreService:GetDataStore("PlayerData_v3")

local function loadData(player)
    local success, data
    for attempt = 1, 5 do
        success, data = pcall(function()
            return PlayerData:GetAsync("user_" .. player.UserId)
        end)
        if success then break end
        task.wait(2 ^ attempt)
    end
    return data or { coins = 0, level = 1, inv = {} }
end

Players.PlayerAdded:Connect(function(player)
    local profile = loadData(player)
    player:SetAttribute("Coins", profile.coins)
    print("Loaded data for", player.Name)
end)`,
  },
  {
    id: "remote",
    label: "RemoteEvents",
    title: "Server-authoritative ability cast",
    description: "Validates the client request, applies cooldown, broadcasts the ability to nearby players.",
    code: `local RS = game:GetService("ReplicatedStorage")
local CastAbility = RS:WaitForChild("Remotes"):WaitForChild("CastAbility")

local cooldowns = {}
local COOLDOWN = 2.5

CastAbility.OnServerEvent:Connect(function(player, abilityId, target)
    local now = os.clock()
    if cooldowns[player.UserId] and now - cooldowns[player.UserId] < COOLDOWN then
        return
    end
    if typeof(abilityId) ~= "string" then return end

    cooldowns[player.UserId] = now
    local origin = player.Character and player.Character.PrimaryPart
    if not origin then return end

    for _, p in ipairs(game.Players:GetPlayers()) do
        if p ~= player and p.Character then
            CastAbility:FireClient(p, player, abilityId, origin.Position)
        end
    end
end)`,
  },
  {
    id: "combat",
    label: "Combat",
    title: "Hitbox raycast with overlap params",
    description: "Sweeping hitbox using GetPartBoundsInBox + Raycast for lag-resistant melee combat.",
    code: `local function meleeSwing(attacker, weapon)
    local root = attacker.Character.HumanoidRootPart
    local cf = root.CFrame * CFrame.new(0, 0, -3)
    local size = Vector3.new(5, 5, 6)

    local op = OverlapParams.new()
    op.FilterDescendantsInstances = { attacker.Character }
    op.FilterType = Enum.RaycastFilterType.Exclude
    op.MaxParts = 10

    local hits = workspace:GetPartBoundsInBox(cf, size, op)
    local damaged = {}
    for _, part in ipairs(hits) do
        local hum = part.Parent:FindFirstChildOfClass("Humanoid")
        if hum and not damaged[hum] then
            damaged[hum] = true
            hum:TakeDamage(weapon.Damage)
        end
    end
end`,
  },
  {
    id: "oop",
    label: "OOP Class",
    title: "Object-oriented Enemy class",
    description: "Metatable-based OOP pattern for spawning, updating, and pooling AI enemies.",
    code: `local Enemy = {}
Enemy.__index = Enemy

function Enemy.new(model, config)
    local self = setmetatable({}, Enemy)
    self.Model = model
    self.Humanoid = model:WaitForChild("Humanoid")
    self.MaxHealth = config.health or 100
    self.Speed = config.speed or 12
    self.Target = nil
    self.Humanoid.MaxHealth = self.MaxHealth
    self.Humanoid.Health = self.MaxHealth
    self.Humanoid.WalkSpeed = self.Speed
    return self
end

function Enemy:Aggro(player)
    self.Target = player
    self.Humanoid:MoveTo(player.Character.HumanoidRootPart.Position)
end

function Enemy:Destroy()
    self.Target = nil
    self.Model:Destroy()
    setmetatable(self, nil)
end

return Enemy`,
  },
  {
    id: "ui",
    label: "UI Tween",
    title: "Animated reward popup",
    description: "TweenService-driven UI with bounce-in, hold, and fade-out using easing curves.",
    code: `local TweenService = game:GetService("TweenService")

local function showReward(gui, amount)
    local label = gui.Frame.Amount
    label.Text = "+" .. amount .. " gold"
    label.TextTransparency = 1
    gui.Frame.Position = UDim2.new(0.5, 0, 1.2, 0)
    gui.Enabled = true

    local pop = TweenInfo.new(0.4, Enum.EasingStyle.Back, Enum.EasingDirection.Out)
    local fade = TweenInfo.new(0.6, Enum.EasingStyle.Quad, Enum.EasingDirection.In, 0, false, 1.2)

    TweenService:Create(gui.Frame, pop, {
        Position = UDim2.new(0.5, 0, 0.85, 0)
    }):Play()
    TweenService:Create(label, fade, { TextTransparency = 0 }):Play()

    task.delay(2, function()
        TweenService:Create(label, fade, { TextTransparency = 1 }):Play()
    end)
end`,
  },
];

// Lightweight Lua syntax highlighter (regex-based, good enough for marketing)
const LUA_KEYWORDS = new Set([
  "and", "break", "do", "else", "elseif", "end", "false", "for", "function",
  "goto", "if", "in", "local", "nil", "not", "or", "repeat", "return",
  "then", "true", "until", "while", "self",
]);
const LUA_GLOBALS = new Set([
  "game", "workspace", "task", "script", "math", "string", "table", "os",
  "typeof", "Enum", "Vector3", "UDim2", "CFrame", "Instance", "TweenInfo",
  "OverlapParams", "setmetatable", "pcall", "ipairs", "pairs", "print",
  "require", "tick",
]);

export function highlightLua(code) {
  const tokens = [];
  const regex = /(--[^\n]*)|("(?:\\.|[^"\\])*")|(\b\d+\.?\d*\b)|([A-Za-z_][A-Za-z0-9_]*)|(\s+)|([^\w\s])/g;
  let m;
  while ((m = regex.exec(code)) !== null) {
    if (m[1]) tokens.push({ t: "com", v: m[1] });
    else if (m[2]) tokens.push({ t: "str", v: m[2] });
    else if (m[3]) tokens.push({ t: "num", v: m[3] });
    else if (m[4]) {
      if (LUA_KEYWORDS.has(m[4])) tokens.push({ t: "kw", v: m[4] });
      else if (LUA_GLOBALS.has(m[4])) tokens.push({ t: "glob", v: m[4] });
      else tokens.push({ t: "fn", v: m[4] });
    } else {
      tokens.push({ t: "plain", v: m[0] });
    }
  }
  return tokens;
}
